import { FaqCategory, FaqItem } from '../store/state/support.state';

export const FAQ_CATEGORIES: FaqCategory[] = [
  { id: 'gettingStarted', label: 'Getting Started' },
  // { id: 'accountSecurity', label: 'Account & Security' },
  // { id: 'savingsInvestments', label: 'Savings & Investments' },
  // { id: 'expensesBilling', label: 'Expenses & Billing' },
  // { id: 'loansCreditCards', label: 'Loans & Credit Cards' },
];

export const FAQ_ITEMS: FaqItem[] = [
  // Getting Started
  {
    id: 1,
    category: 'gettingStarted',
    question: 'How do I create a Capvizon account?',
    answer:
      'Visit the Capvizon app or website and click "Sign Up". Enter your first name, last name, email address, and a secure password. Once submitted you will receive a verification email — confirm it and your account is ready to use.',
  },
  {
    id: 2,
    category: 'gettingStarted',
    question: 'How do I sign in to my account?',
    answer:
      'Click "Sign In" on the landing page, enter your registered email address and password, then click "Login". If you have forgotten your password, use the "Forgot Password" link to receive a reset email.',
  },
  {
    id: 3,
    category: 'gettingStarted',
    question: 'How do I reset a forgotten password?',
    answer:
      'On the Sign In page click "Forgot Password". Enter your registered email address and submit. You will receive a password reset link via email. Follow the link, enter a new password, and confirm it to regain access.',
  },
  {
    id: 4,
    category: 'gettingStarted',
    question: 'What can I do from the Home dashboard?',
    answer:
      'The Home dashboard gives you an at-a-glance Overview of your Savings, Stocks, Credit Cards, Loans, and Expenses balances. You can also manage Contacts and view recent transactions from this page.',
  },

  // Account & Security
  // {
  //   id: 5,
  //   category: 'accountSecurity',
  //   question: 'How do I update my profile information?',
  //   answer:
  //     'Navigate to Account Settings from the user dropdown menu in the top-right corner. From there you can update your first name, last name, phone number, email address, and home address.',
  // },
  // {
  //   id: 6,
  //   category: 'accountSecurity',
  //   question: 'How do I change my password?',
  //   answer:
  //     'Go to Account Settings and select the Security section. Enter your current password followed by your new password and confirm it. Click Save to apply the change.',
  // },
  // {
  //   id: 7,
  //   category: 'accountSecurity',
  //   question: 'How do I add or manage contacts?',
  //   answer:
  //     'From the Home page click the "+ ADD" button in the Contacts section. Search for a user by email address and send a contact request. Once the other user accepts, they will appear in your contacts list and can be included in shared expenses.',
  // },
  // {
  //   id: 8,
  //   category: 'accountSecurity',
  //   question: 'What notifications will I receive?',
  //   answer:
  //     'You will receive notifications for contact requests, expense invitations, payment reminders, and important account activity. Check the Notifications section in the user dropdown to view and manage them.',
  // },

  // // Savings & Investments
  // {
  //   id: 9,
  //   category: 'savingsInvestments',
  //   question: 'How do I track my savings?',
  //   answer:
  //     'Navigate to the Savings page from the top navigation bar. Here you can view your total savings balance and add or manage individual savings accounts.',
  // },
  // {
  //   id: 10,
  //   category: 'savingsInvestments',
  //   question: 'How do I track my stock investments?',
  //   answer:
  //     'Go to the Stocks section from the top navigation. The dashboard shows your total invested amount. You can add new investment entries and monitor the performance of your portfolio over time.',
  // },
  // {
  //   id: 11,
  //   category: 'savingsInvestments',
  //   question: 'Where can I see an overview of all my balances?',
  //   answer:
  //     'The Home page Overview panel displays a summary of all your financial balances — Savings, Stocks, Credit Cards, Loans, and Expenses — in one place for a quick financial snapshot.',
  // },

  // // Expenses & Billing
  // {
  //   id: 12,
  //   category: 'expensesBilling',
  //   question: 'How do I add a new expense?',
  //   answer:
  //     'Go to the Expenses page and click "+ ADD EXPENSE". Fill in the expense name, who paid, who the expense is lent to, the total amount, sharing type (equally or custom percentage), and the transaction date. Click "ADD" to save.',
  // },
  // {
  //   id: 13,
  //   category: 'expensesBilling',
  //   question: 'How does the expense splitter work?',
  //   answer:
  //     'The Splitter feature automatically divides shared expenses among participants. Choose "EQUALLY" to split the amount evenly, or set custom percentages for each person. Capvizon calculates each participant\'s allocated share automatically.',
  // },
  // {
  //   id: 14,
  //   category: 'expensesBilling',
  //   question: 'What is the difference between Pending and Settled payments?',
  //   answer:
  //     'Pending Payments are expenses where money is still owed between participants. Settled Payments are expenses that have been fully resolved. The Expenses page shows your "You Owe" and "You Lent" totals to help you track outstanding balances.',
  // },
  // {
  //   id: 15,
  //   category: 'expensesBilling',
  //   question: 'Can I edit or delete an existing expense?',
  //   answer:
  //     'Yes. From the Expenses page click "View" on any expense card to see its details. Use the "EDIT" button to modify the expense or "DELETE" to remove it. Click "CLOSE" to collapse the details panel.',
  // },

  // // Loans & Credit Cards
  // {
  //   id: 16,
  //   category: 'loansCreditCards',
  //   question: 'How do I track my loans?',
  //   answer:
  //     'Navigate to the Loans section from the top navigation bar. You can view your total borrowed amount and the remaining balance across all your loan accounts.',
  // },
  // {
  //   id: 17,
  //   category: 'loansCreditCards',
  //   question: 'How do I manage my credit cards?',
  //   answer:
  //     'Go to the Credit Cards page to view your total cards limit and available balance. You can add new credit card accounts and monitor how much credit you have remaining.',
  // },
  // {
  //   id: 18,
  //   category: 'loansCreditCards',
  //   question: 'How is the available credit card balance calculated?',
  //   answer:
  //     'The available balance shown on the Credit Cards overview is your total cards limit minus the amounts you have used. This gives you a real-time view of how much credit you can still utilise.',
  // },
];
